import { Icon, IconProps } from "@chakra-ui/react";

export const Dragon = (props: IconProps) => {
  return (
    <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 216" fill="none" {...props}>
      <path fill="#343436" d="M8 200h8v4H8v-4ZM20 200h4v4h-4v-4ZM64 204H48v-4H36v4h-8v4h36v-4ZM72 200h-4v4h4v-4Z" />
      <path fill="#382A1E" d="M12 92h4v20h-4z" />
      <path fill="#4F3C2B" d="M16 92h4v16h-4zM16 116h4v4h-4zM12 140h4v16h-4zM20 92h4v8h-4z" />
      <path fill="#382A1E" d="M8 144h4v12H8z" />
      <path fill="#0D1114" d="M8 112h4v32H8z" />
      <path fill="#1A1A1A" d="M16 112h-4v28h4v-4h4v4h4v-8h-4v-4h-4v-16ZM16 156h-4v20h4v-20Z" />
      <path fill="#0D1114" d="M8 156h4v4H8zM8 168h4v4H8z" />
      <path fill="#F3EBEE" d="M52 52h4v4h-4v-4ZM52 60h-4v-4h4v4Z" />
      <path
        fill="#F3EBEE"
        fillRule="evenodd"
        d="M52 64v-4h4v-4h8v4h4v24h-4V72h-4v48h-4v4h-4v4H36v-4h-4V76h-4v-4h4v-4h-4v4h-4v4h-4v8h-4V72h4V60h8v-4h12v4h4v4h8Zm0 0h4v4h-4v-4Zm0 20h-4v-8h4v4h4v8h-4v-4Zm4 24v4h-4v-4h4ZM40 72h-4v4h4v-4Zm0 24h-4v4h4v-4Z"
        clipRule="evenodd"
      />
      <path fill="#701616" d="M28 124h4v4h-4zM48 80h4v4h-4zM52 84h4v4h-4z" />
      <path
        fill="#A32121"
        d="M56 64h-4v4h4v-4ZM32 68h-4v4h4v-4ZM40 72h-4v4h4v-4ZM48 76h4v4h-4v-4ZM52 80v4h4v-4h-4ZM36 96h4v4h-4v-4ZM56 108h-4v4h4v-4ZM56 120h4v8h-8v-4h4v-4ZM32 124h4v4h-4v-4Z"
      />
      <path fill="#C2BCBE" d="M36 52h-8v4h-8v4h-4v12h-4v12h4V72h4V60h8v-4h8v-4Z" />
      <path fill="#C2BCBE" d="M24 72h4v4h4v48h-4v4h-4V80h-4v-4h4v-4ZM64 72h-4v12h4V72Z" />
      <path fill="#343434" d="M32 128h28v28h-8v-4h4v-12H36v16h-8v-4h4v-24ZM28 160h4v20h-4v-20ZM56 160h-4v20h4v-20Z" />
      <path
        fill="#121212"
        d="M32 128h-8v56h8v-4h-4v-20h4v-4h-4v-4h4v-24ZM48 184h8v-4h-4v-20h4v-4h-4v-4h4v-12h-8v44ZM32 192h-4v4h-4v8h12v-8h-4v-4ZM68 196h-8v4H48v4h20v-8ZM48 192h4v4h-4v-4Z"
      />
      <path fill="#404040" d="M48 196h12v4H48zM56 192h4v4h-4zM32 192h4v4h-4zM24 192h4v4h-4z" />
      <path
        fill="#77F8F8"
        d="M44 44h4v4h-4v-4ZM44 52h8v4h-4v4h-4v-8ZM20 84h-4v8h4v-8ZM64 84h4v36h-4v-4h-4v-4h4V84ZM64 120v4h-4v-4h4ZM32 184h-4v8h4v-8ZM56 184h-4v8h4v-8ZM20 108h-4v8h4v4h-4v4h4v-4h4v-4h-4v-8Z"
      />
      <path fill="#DE9400" d="M36 52h4v4h-4zM40 56h4v4h-4zM44 60h8v4h-8zM52 56h4v4h-4z" />
      <path
        fill="#3CCBCB"
        d="M40 44h4v4h4v4h-4v4h-4V44ZM12 84h4v8h-4v-8ZM28 184h-4v4h4v-4ZM48 184h4v8h-4v-8ZM64 84h-4v28h4V84Z"
      />
      <path
        fill="#1F1F1F"
        d="M24 188h4v4h-4v-4ZM32 188h4v4h-4v-4ZM56 192h-4v4h4v-4ZM60 192h-4v-4h4v4ZM60 192v4h4v-4h-4Z"
      />
      <path fill="#DB2C2C" d="M44 16v4h4v4h4v-8h-8ZM52 28h-4v4h4v4h8v-4h-8v-4ZM64 32h4v8h-4v-8Z" />
      <path fill="#32662E" d="M32 20h-4v4h-4v4h8v-8ZM28 32h-4v4h-4v4h-4v4h-4v4h4v-4h4v-4h8v-8Z" />
      <path fill="#254D22" d="M36 20h-4v8h-4v12h-8v4h8v-4h8v-4h-4v-8h4v-8Z" />
      <path
        fill="#3E8039"
        d="M12 12h4v4h-4v-4ZM24 20v-4h-8v4h8ZM24 24v-4h4v4h-4ZM24 28v-4H12v-4H8v4h4v4h12ZM24 32h4v-4h-4v4ZM24 32H12v4h12v-4ZM32 12h-4v4h4v4h4v-4h-4v-4ZM40 28h4v4h-4v-4ZM56 28h-4v4h4v-4Z"
      />
      <path
        fill="#F2A54A"
        d="M32 8h-4v4h4v4h4v4h4v-4h-4v-4h-4V8ZM56 8h4v8h-4V8ZM56 16v4h-4v-4h4ZM64 28h-4v8h4v-8ZM68 28h4v8h-4v-8Z"
      />
      <path fill="#F1C092" d="M40 36h4v4h-4zM36 32h4v4h-4zM44 36h4v4h-4z" />
      <path fill="#F5E8D7" d="M36 20h8v4h-8v-4ZM60 20h-8v4h-4v4h4v-4h8v-4Z" />
      <path fill="#000" d="M36 24h8v4h-8v-4ZM44 28h4v4h-4v-4ZM48 40v4h12v-4H48ZM52 24h8v4h-8v-4Z" />
      <path fill="#A92223" d="M44 16h-4v4h4v8h4v-8h-4v-4Z" />
      <path
        fill="#A92223"
        fillRule="evenodd"
        d="M32 28v8h4v4h4v4h8v4h16v-4H48v-4h16v-4H52v-4H40v-4h-8Zm8 8h8v4h-8v-4Zm0 0v-4h-4v4h4Z"
        clipRule="evenodd"
      />
      <g
        fill="#0A8F4F"
        style={{
          mixBlendMode: "color",
        }}
      >
        <path
          fillRule="evenodd"
          d="M32 8h-4v8h4v4h-8v-4h-8v-4h-4v4h4v4h8v4H12v-4H8v4h4v4h12v4H12v4h8v4h-4v4h-4v4h4v-4h12v-4h12v12H28v4h-8v4h-4v12h-4v40H8v48h4v8H8v4h4v4h4v-40h4v4h4v60h-4v4h8v4h36v-4h8v-4h-4v-4h-4v-4h-4v-4h-4v-32h4v-32h4v-4h4V60h-4v-4h-8v-4h-8v-4h16v-4h-4v-4h8v-4h4v-8h-4v4h-4v-4h-4v-8h-4v-4h4V8h-4v8H36v-4h-4V8Zm28 20v4h-4v-4h4Zm4 92v-4h-4v4h4Zm-16 20H36v16h-4v32h4v12h12v-60ZM20 92V80h4v12h-4Zm-4 32h4v-4h4v12h-4v-4h-4v-4Zm4-24h4v16h-4v-16Z"
          clipRule="evenodd"
        />
        <path d="M16 200v4H8v-4h8Z" />
      </g>
    </Icon>
  );
};

export const DragonIcon = ({ color, ...props }: IconProps) => {
  return (
    <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 24V21H21V19.5H18V18H16.5V19.5H15V21H16.5V22.5H13.5V21H12V19.5H7.5V21H4.5V24H16.5V22.5H18V24H22.5ZM16.5 21V19.5H18V21H16.5Z"
        fill="#F3EBEE"
      />
      <path d="M16.5 24H18V22.5H16.5V24Z" fill="#A32121" />
      <path d="M4.5 24H3V21H4.5V24Z" fill="#C2BCBE" />
      <path d="M7.5 19.5V21H4.5V19.5H7.5Z" fill="#C2BCBE" />
      <path d="M7.5 19.5V18H10.5V19.5H7.5Z" fill="#C2BCBE" />
      <path d="M15 15H13.5V16.5H15V15Z" fill="#77F8F8" />
      <path d="M16.5 19.5V18H13.5V21H15V19.5H16.5Z" fill="#77F8F8" />
      <rect x="10.5" y="18" width="1.5" height="1.5" fill="#DE9400" />
      <rect x="12" y="19.5" width="1.5" height="1.5" fill="#DE9400" />
      <rect x="13.5" y="21" width="3" height="1.5" fill="#DE9400" />
      <rect x="16.5" y="19.5" width="1.5" height="1.5" fill="#DE9400" />
      <path d="M12 15H13.5V16.5H15V18H13.5V19.5H12V15Z" fill="#3CCBCB" />
      <path d="M13.5 4.5V6H15V7.5H16.5V4.5H13.5Z" fill="#DB2C2C" />
      <path d="M16.5 9H15V10.5H16.5V12H19.5V10.5H16.5V9Z" fill="#DB2C2C" />
      <path d="M21 10.5H22.5V13.5H21V10.5Z" fill="#DB2C2C" />
      <path d="M9 6H7.5V7.5H6V9H9V6Z" fill="#32662E" />
      <path d="M7.5 10.5H6V12H4.5V13.5H3V15H1.5V16.5H3V15H4.5V13.5H7.5V10.5Z" fill="#32662E" />
      <path d="M10.5 6H9V9H7.5V13.5H4.5V15H7.5V13.5H10.5V12H9V9H10.5V6Z" fill="#254D22" />
      <path d="M1.5 3H3V4.5H1.5V3Z" fill="#3E8039" />
      <path d="M6 6V4.5H3V6H6Z" fill="#3E8039" />
      <path d="M6 7.5V6H7.5V7.5H6Z" fill="#3E8039" />
      <path d="M6 9V7.5H1.5V6H0V7.5H1.5V9H6Z" fill="#3E8039" />
      <path d="M6 10.5H7.5V9H6V10.5Z" fill="#3E8039" />
      <path d="M6 10.5H1.5V12H6V10.5Z" fill="#3E8039" />
      <path d="M9 3H7.5V4.5H9V6H10.5V4.5H9V3Z" fill="#3E8039" />
      <path d="M12 9H13.5V10.5H12V9Z" fill="#3E8039" />
      <path d="M18 9H16.5V10.5H18V9Z" fill="#3E8039" />
      <path d="M9 1.5H7.5V3H9V4.5H10.5V6H12V4.5H10.5V3H9V1.5Z" fill="#F2A54A" />
      <path d="M18 1.5H19.5V4.5H18V1.5Z" fill="#F2A54A" />
      <path d="M18 4.5V6H16.5V4.5H18Z" fill="#F2A54A" />
      <path d="M21 9H19.5V12H21V9Z" fill="#F2A54A" />
      <path d="M22.5 9H24V12H22.5V9Z" fill="#F2A54A" />
      <rect x="12" y="12" width="1.5" height="1.5" fill="#F1C092" />
      <rect x="10.5" y="10.5" width="1.5" height="1.5" fill="#F1C092" />
      <rect x="13.5" y="12" width="1.5" height="1.5" fill="#F1C092" />
      <path d="M10.5 6H13.5V7.5H10.5V6Z" fill="#F5E8D7" />
      <path d="M19.5 6H16.5V7.5H15V9H16.5V7.5H19.5V6Z" fill="#F5E8D7" />
      <path d="M10.5 7.5H13.5V9H10.5V7.5Z" fill="black" />
      <path d="M13.5 9H15V10.5H13.5V9Z" fill="black" />
      <path d="M15 13.5V15H19.5V13.5H15Z" fill="black" />
      <path d="M16.5 7.5H19.5V9H16.5V7.5Z" fill="black" />
      <path d="M13.5 4.5H12V6H13.5V9H15V6H13.5V4.5Z" fill="#A92223" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 9V12H10.5V13.5H12V15H15V16.5H21V15H15V13.5H21V12H16.5V10.5H12V9H9ZM12 12H15V13.5H12V12ZM12 12V10.5H10.5V12H12Z"
        fill="#A92223"
      />

      <g
        style={{
          mixBlendMode: "color",
        }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 6V7.5H1.5V9H6V10.5H1.5V12H4.5V13.5H3V15H1.5V16.5H3V15H7.5V13.5H12V18H7.5V19.5H4.5V21H3V24H22.5V21H21V19.5H18V18H15V16.5H21V15H19.5V13.5H22.5V12H24V9H22.5V10.5H21V9H19.5V6H18V4.5H19.5V1.5H18V4.5H10.5V3H9V1.5H7.5V4.5H9V6H6V4.5H3V3H1.5V4.5H3V6H6V7.5H1.5V6H0ZM19.5 9H18V10.5H19.5V9Z"
          fill={color as string}
        />
      </g>
    </Icon>
  );
};
